import { render, staticRenderFns } from "./contato.vue?vue&type=template&id=41f21ed4&scoped=true&"
import script from "./contato.vue?vue&type=script&lang=js&"
export * from "./contato.vue?vue&type=script&lang=js&"
import style0 from "./contato.vue?vue&type=style&index=0&id=41f21ed4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f21ed4",
  null
  
)

export default component.exports